import { render, staticRenderFns } from "./attachmentShow.vue?vue&type=template&id=38058a09&scoped=true"
import script from "./attachmentShow.vue?vue&type=script&lang=js"
export * from "./attachmentShow.vue?vue&type=script&lang=js"
import style0 from "./attachmentShow.vue?vue&type=style&index=0&id=38058a09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38058a09",
  null
  
)

export default component.exports